import {
  Text as ChakraText,
  Heading as ChakraHeading,
  type TextProps as ChakraTextProps,
  type HeadingProps as ChakraHeadingProps,
} from '@chakra-ui/react';
import { useTheme } from '../provider/useTheme';
import type { SemanticColorToken } from '../themes/types';
import type { TranslationValue } from './translation';
import { Translation } from './translation';
import type { FontToken } from '../typography/types';
/**
 * @deprecated Use `CoreTextProps` from `@vitvio/design-system` instead.
 */
export interface TextProps extends ChakraTextProps {
  path?: string;
  value?: TranslationValue;
  colorToken?: SemanticColorToken;
  font?: FontToken;
}

/**
 * @deprecated Use `CoreText` from `@vitvio/design-system` instead. Example:
 *   <CoreText color="fg.muted" font="M_SemiBold" path="common:text" />
 */
export const Text = ({ path, children, value, colorToken = 'fg', font = 'M_Regular', ...props }: TextProps) => {
  const { getColor, getFont } = useTheme();

  const fontProperties = font ? getFont(font) : undefined;
  return (
    <Translation
      path={path}
      children={children}
      value={value}
      render={(content) => (
        <ChakraText
          color={getColor(colorToken)}
          fontFamily={fontProperties?.fontFamily}
          fontSize={fontProperties?.size}
          fontWeight={fontProperties?.weight}
          lineHeight={`${fontProperties?.lineHeight}px`}
          letterSpacing={fontProperties?.letterSpacing}
          {...props}
        >
          {content}
        </ChakraText>
      )}
    />
  );
};

// Heading component with translation support
export interface HeadingProps extends ChakraHeadingProps {
  path?: string;
  value?: TranslationValue;
}

/**
 * @deprecated Use `CoreText` from `@vitvio/design-system` instead. Example:
 *   <CoreText color="fg.muted" font="M_SemiBold" path="common:headingText" />
 */
export const Heading = ({ path, children, value, ...props }: HeadingProps) => {
  return (
    <Translation
      path={path}
      children={children}
      value={value}
      render={(content) => <ChakraHeading {...props}>{content}</ChakraHeading>}
    />
  );
};
